import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Public pages
import LandingPage from './components/LandingPage';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import PropositionForm from './components/PropositionForm';
import SharedPVView from './components/SharedPVView';


// Protected pages
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import PVForm from './components/PVForm';
import PVPreview from './components/PVPreview';
import MembersManagement from './components/MembersManagement';
import ClubSettings from './components/ClubSettings';
import PropositionsPage from './components/PropositionsPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/propositions/:sessionToken" element={<PropositionForm />} />
            <Route path="/shared/:shareToken" element={<SharedPVView />} />

            
            {/* Protected routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } />
            
            <Route path="/members" element={
              <ProtectedRoute>
                <MembersManagement />
              </ProtectedRoute>
            } />
            
            <Route path="/pv/new" element={
              <ProtectedRoute>
                <PVForm />
              </ProtectedRoute>
            } />
            
            <Route path="/pv/:id/edit" element={
              <ProtectedRoute>
                <PVForm />
              </ProtectedRoute>
            } />
            
            <Route path="/pv/:id" element={
              <ProtectedRoute>
                <PVPreview />
              </ProtectedRoute>
            } />
            
            <Route path="/preview/:id" element={
              <ProtectedRoute>
                <PVPreview />
              </ProtectedRoute>
            } />
            
            <Route path="/club-settings" element={
              <ProtectedRoute>
                <ClubSettings />
              </ProtectedRoute>
            } />
            
            <Route path="/propositions-management" element={
              <ProtectedRoute>
                <PropositionsPage />
              </ProtectedRoute>
            } />
            
            {/* Redirect old routes */}
            <Route path="/home" element={<Navigate to="/dashboard" replace />} />
            
            {/* Catch all - redirect to landing */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;